import Plant from "@/domainObjects/Plant";
import Subscription from "@/domainObjects/Subscription";

export default class Email {

    static readonly SUBSCRIPTIONS_ALL: number = 63;

    firstName: string;
    lastName: string;
    plant: Plant;
    email: string;
    edit: boolean;
    loaded: boolean;
    subscribeFlag: number;
    subscriptions: Subscription;

    constructor(){
        this.firstName = "";
        this.lastName = "";
        this.plant = new Plant();
        this.email = "";
        this.edit = false;
        this.loaded = false;
        this.subscribeFlag = 0;
        this.subscriptions = new Subscription(0);
    }

    initFromObject( email ){
        this.firstName = email.firstName;
        this.lastName = email.lastName;
        this.plant = email.plant;
        this.email = email.email;
        this.edit = false;
        this.loaded = email.loaded;
        this.subscribeFlag = email.subscribeFlag;
        this.subscriptions = new Subscription(this.subscribeFlag);
    }
}